module.exports = Object.freeze({
    PENDING: { value: 1, name: 'Pending' },
    APPROVED: { value: 2, name: 'Approved' },
    REJECTED: { value: 3, name: 'Rejected' },
    NA: { value: 4, name: 'NA' },
    AUTOMATIC: { value: 5, name: 'Automatic Approval' }
});
